<div class="dialog-wrapper" role="dialog" aria-modal="true" aria-labelledby="not-found-title">

  <button class="close-btn" type="button" (click)="close()" aria-label="Cerrar">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="dialog-icon" aria-hidden="true">
    <div class="icon-circle">
      <img src="assets/agricola/toast-idea.svg" alt="">
    </div>
  </div>

  <h2 id="not-found-title">Cliente no encontrado</h2>
  <p class="subtitle">
    Utiliza otros criterios de búsqueda o realiza<br>
    la vinculación del cliente desde PORTAL
  </p>

  <div class="dialog-actions">
    <app-sis-button variant="secondary" (pressed)="close()">NUEVA BUSQUEDA</app-sis-button>
  </div>

</div>
